import React from 'react';
import { Skeleton } from './Skeleton';

export const StatsSkeleton: React.FC = () => {
  return (
    <div className="arcade-panel pixel-corners rounded-lg border p-4 bg-white/5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Skeleton variant="circular" className="h-12 w-12" />
          <div className="space-y-2">
            <Skeleton variant="text" className="h-3 w-16" />
            <Skeleton variant="text" className="h-6 w-32" />
          </div>
        </div>
        <div className="text-right space-y-2">
          <Skeleton variant="text" className="h-3 w-16 ml-auto" />
          <Skeleton variant="text" className="h-6 w-20 ml-auto" />
        </div>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="space-y-1">
            <Skeleton variant="text" className="h-3 w-12" />
            <Skeleton variant="text" className="h-5 w-8" />
          </div>
        ))}
      </div>
    </div>
  );
};
